export default __webpack_public_path__ + "static/media/camera-icon.1b813e05.svg";